/**
 *
 * This object contains the DH FwF Experimentation Toggles used in the application.
 * They must be defined using the following pattern: <LAYER_NAME>$$$<PARAMETER_NAME>
 * Example: Customer_Web$$$MtExperimentEnabled
 *
 * DH FwF Experiment Toggles BackOffice:
 * https://management.fwf.deliveryhero.net/glovo/default/staging/layers
 *
 */
export const experimentationToggles = {
  Customer_WeB$$$TestExperimentEnabled: { enabled: false }, // delete Jira ticket here
}
